<template>
<div class="chapter">
<div class="inner_page">
<p><a id="cop"></a></p><a id="cop">
<div class="crt">Copyright © 2007 by Dawn-Michelle Baude, Ph.D.</div>
<div> <br/><br/></div><div class="crt">All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.</div>
<div> <br/><br/></div><div class="crt">The e-mail documents in this book are based on actual e-mail the author has read and collected. Identifying details have been altered prior to publication. Any resemblence to actual businesses and employees is purely coincidental.</div>
<div> <br/><br/></div><div class="crt"><b>THE EXECUTIVE GUIDE TO E-MAIL CORRESPONDENCE</b> <br/><br/>EDITED AND TYPESET BY ASTRID DERIDDER <br/><br/>Cover design by Howard Grossman/12E Design <br/><br/>Printed in the U.S.A. by Book-mart Press</div>
<div> <br/><br/></div><div class="crt">To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further information on books from Career Press.</div>
<div class="centerAligned"><img alt="002" class="imgepub" src="bano_9781601638632_oeb_002_r1.gif"/></div>
</a><div class="crt"><a id="cop">The Career Press, Inc., 3 Tice Road, PO Box 687, Franklin Lakes, NJ 07417  <b></b></a><b><a href="http://www.careerpress.com" target="_blank">www.careerpress.com</a>  Library of Congress Cataloging-in-Publication Data</b>  Baude, Dawn Michelle, 1959-The Executive guide to e-mail correspondence : including model letters for every situation / by Dawn-Michelle Baude. p. cm. Includes bibliographical references and index.</div>
<div class="crt">ISBN-13: 978-1-56414-910-7 ISBN-10: 1-56414-910-2</div><div class="crt">eISBN : 	97-8-160-16386-3</div>
<div class="crt">1. Electronic mail messages. 2. Letter writing. I. Title. HE7551.B38 2006 651.7’9--dc22 2006023656</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bano_9781601638632_oeb_cop_r1.vue?8db68152